module.exports = __webpack_public_path__ + "static/media/banknote-18.11bb491d.svg";